import { errorWrapper } from 'utility/error';

import type { CalculatedInternalRequest } from './__GENERATED';
import { apiClient } from './api';
import { toCalculatedInternalDomain } from './transformers/toCalculatedInternalDomain';

// Fetches calculated internals for a tenant and maps them onto the `Data.CalculatedInternal` domain.
// `returnRawData: true` returns day-level aggregated rows rather than computed KPI values.
// `dates: null` fetches the full history; selectors slice by date downstream.
// `unitOfMeasureId: null` omits the unit filter so all measurement types are returned.
async function getCalculatedInternals(args: {
  tenantId: string;
  resolution: CalculatedInternalRequest['resolution'];
  bucketResolution: CalculatedInternalRequest['bucketResolution'];
}) {
  const { tenantId, resolution, bucketResolution } = args;

  const apiCall = apiClient.Internal_GetCalculatedInternals(
    {
      resolution,
      bucketResolution,
      unitOfMeasureId: null,
      returnRawData: true,
      dates: null,
    },
    {
      params: { tenantId },
    },
  );

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to load calculated internals',
    },
    onSuccess: (dtos) => {
      const { calculatedInternalDomain } = toCalculatedInternalDomain({
        dtos: dtos ?? [],
      });
      return { calculatedInternalDomain };
    },
  });
}

export { getCalculatedInternals };
